import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1'

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Add JWT token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const designService = {
  renderDesign: (templateType, item1, item2) => {
    const payload = {
      template_type: templateType,
      item1: {
        name: item1.name,
        quantity: item1.quantity,
        price: item1.price,
        image_filename: item1.image_filename
      }
    }

    if (templateType === 'double' && item2) {
      payload.item2 = {
        name: item2.name,
        quantity: item2.quantity,
        price: item2.price,
        image_filename: item2.image_filename
      }
    }

    return api.post('/designs/render', payload)
  },

  bulkUpload: (file, templateMode) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('template_mode', templateMode)

    return api.post('/designs/bulk-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  listImages: () => api.get('/images'),

  uploadImage: (formData) => {
    return api.post('/images/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  listDesigns: (skip = 0, limit = 20) => api.get('/designs', { params: { skip, limit } }),

  getDesign: (designId) => api.get(`/designs/${designId}`),

  deleteDesign: (designId) => api.delete(`/designs/${designId}`),

  batchDeleteDesigns: (designIds) => api.post('/designs/batch-delete', designIds),

  getTemplates: () => api.get('/templates')
}
